import React from 'react';
import {Card} from "antd";
import QrCode from "../../../Component/QrCode";
import PaymentVoucherDomain from "../../../Domain/PaymentVoucherDomain";
import Utils from "../../../Util/Utils";

interface Props {
    paymentVoucher: PaymentVoucherDomain
}

class VoucherQrCode extends React.Component<Props, any> {

    render() {
        const {paymentVoucher} = this.props;
        return (
            <Card title={"Mã QR"} className={'mg-bt-12'}>
                <QrCode value={Utils.buildUrl(window.location, `/payment-vouchers/${paymentVoucher.code}`)} />
            </Card>
        )
    }
}

export default VoucherQrCode;